import React from 'react';
import { useParams } from 'react-router-dom';

const EventDetail = () => {
  const { id } = useParams();
  
  // In a real app, you would fetch this data from an API or context
  const event = {
    id: 1,
    image: "../assets/images/banner1.jpg",
    alt: "Group collaborating in office",
    time: "7:00 pm - 9:00 pm",
    date: { day: "18", month: "Dec" },
    title: "Creative Teaching Seminar Master Class",
    description: "Lorem ipsum dolor sit amet consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore…",
    location: "Ontario City, Canada",
    fullDescription: `
      <p>This comprehensive master class will explore innovative teaching methodologies that engage students in creative ways.</p>
      <p><strong>Key topics include:</strong></p>
      <ul>
        <li>Interactive learning techniques</li>
        <li>Classroom engagement strategies</li>
        <li>Technology integration in education</li>
        <li>Assessment through creative projects</li>
      </ul>
      <p>The seminar will be led by Dr. Jane Smith, an award-winning educator with 15 years of experience in curriculum development.</p>
    `,
    speakers: [
      {
        name: "Dr. Jane Smith",
        role: "Lead Educator",
        bio: "Specialist in creative pedagogy with multiple awards in education innovation.",
        image: "../assets/images/banner3.jpg"
      },
      {
        name: "Prof. John Doe",
        role: "Technology Integration Expert",
        bio: "Pioneer in educational technology with 20 published papers on the subject.",
        image: "../assets/images/banner4.jpg"
      }
    ],
    schedule: [
      { time: "7:00 pm - 7:30 pm", activity: "Registration & Networking" },
      { time: "7:30 pm - 8:15 pm", activity: "Keynote Presentation" },
      { time: "8:15 pm - 8:45 pm", activity: "Interactive Workshop" },
      { time: "8:45 pm - 9:00 pm", activity: "Q&A Session" }
    ]
  };

  return (
    <>
    <section className="Subpage_Hero">
      <div className="container">
        <div className="text-lg-start text-center" data-aos="fade-up">
          <h1>Our Classes</h1>
          <p>
            Lorem ipsum dolor sit amet consectetur. Quis sed donec quis nunc
            aliquet cursus mauris ut. Enim fermentum maecenas rutrum dapibus
            sodales quis. Pulvinar consectetur amet cursus netus at.
          </p>
        </div>
      </div>
    </section>
    <div className="container py-5">
      <div className="row">
        <div className="col-lg-8">
          <div className="card border-0 shadow-sm mb-4">
            <img 
              src={event.image} 
              alt={event.alt} 
              className="card-img-top w-100 rounded-top" 
              style={{ height: '400px', objectFit: 'cover' }}
            />
            <div className="card-body">
              <div className="d-flex align-items-center mb-3">
                <div className="bg-success text-white rounded-circle d-flex flex-column justify-content-center align-items-center me-3" 
                  style={{ width: '70px', height: '70px' }}>
                  <span className="fw-bold fs-5">{event.date.day}</span>
                  <span className="text-uppercase fs-6">{event.date.month}</span>
                </div>
                <div>
                  <h1 className="h4 mb-1 fw-bold">{event.title}</h1>
                  <div className="d-flex align-items-center text-muted">
                    <i className="bi bi-clock me-2"></i>
                    <span className="me-3">{event.time}</span>
                    <i className="bi bi-geo-alt-fill me-2"></i>
                    <span>{event.location}</span>
                  </div>
                </div>
              </div>
              
              <div className="mb-4" dangerouslySetInnerHTML={{ __html: event.fullDescription }} />
              
              <div className="mb-4">
                <h3 className="h5 fw-bold mb-3">Event Schedule</h3>
                <ul className="list-group list-group-flush">
                  {event.schedule.map((item, index) => (
                    <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                      <span>{item.activity}</span>
                      <span className="badge bg-primary rounded-pill">{item.time}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
        
        <div className="col-lg-4">
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-header bg-primary text-white">
              <h3 className="h5 mb-0">Event Details</h3>
            </div>
            <div className="card-body">
              <ul className="list-unstyled">
                <li className="mb-3">
                  <i className="bi bi-calendar-event text-primary me-2"></i>
                  <strong>Date:</strong> {event.date.day} {event.date.month}
                </li>
                <li className="mb-3">
                  <i className="bi bi-clock text-primary me-2"></i>
                  <strong>Time:</strong> {event.time}
                </li>
                <li className="mb-3">
                  <i className="bi bi-geo-alt text-primary me-2"></i>
                  <strong>Location:</strong> {event.location}
                </li>
                <li className="mb-3">
                  <i className="bi bi-people text-primary me-2"></i>
                  <strong>Available Seats:</strong> 50
                </li>
              </ul>
              <button className="btn btn-primary w-100">Register Now</button>
            </div>
          </div>

          <div className="card border-0 shadow-sm">
            <div className="card-header bg-primary text-white">
              <h3 className="h5 mb-0">Speakers</h3>
            </div>
            <div className="card-body">
              {event.speakers.map((speaker, index) => (
                <div key={index} className="d-flex mb-3">
                  <img 
                    src={speaker.image} 
                    alt={speaker.name} 
                    className="rounded-circle me-3" 
                    style={{ width: '60px', height: '60px', objectFit: 'cover' }}
                  />
                  <div>
                    <h4 className="h6 mb-1 fw-bold">{speaker.name}</h4>
                    <p className="small text-muted mb-1">{speaker.role}</p>
                    <p className="small">{speaker.bio}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default EventDetail;